import { Grid, Button, makeStyles } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";

export default function LoginOrCreateAccount() {
  const history = useHistory();
  const classes = useStyles();

  return (
    <Grid
      container
      justify="center"
      direction="column"
      alignItems="center"
      style={{ minHeight: "200px" }}
    >
      <Button
        onClick={() => {
          history.push(`/login`);
        }}
        variant="contained"
        color="primary"
        className={classes.login}
        style={{ fontWeight: "bold" }}
      >
        Login
      </Button>
      <p style={{ marginTop: "15px", marginBottom: "15px" }}>OR</p>
      <Button
        onClick={() => {
          history.push(`/createacc`);
        }}
        variant="outlined"
        color="primary"
        className={classes.create}
        style={{ fontWeight: "bold" }}
      >
        Create an account
      </Button>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  login: {
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "80%",
    },
    color: "white",
  },
  create: {
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "80%",
    },
  },
}));
